import React from "react";

const StatsComponent = ({ percentage, description }) => {
  return (
    <div className="space-4 ">
      <h2 className="text-[44px] font-bold text-[#433CAE]">{percentage}%</h2>
      <p className="text-[#1C1C1C] font-medium ">{description}</p>
    </div>
  );
};

export default StatsComponent;
